import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { Video } from "../ui/video";
import { Section } from "./section";

type VideoFullProps = {
  source: string;
  poster?: string;
  title: string;
  description: string;
  uploadDate?: string;
  duration?: string;
  sectionTitle?: string;
  sectionDescription?: string;
  textAlign?: "center" | "left";
  onPlay?: () => void;
  onEnded?: () => void;
};

export function VideoFull({ sectionTitle, sectionDescription, textAlign = "center", ...props }: VideoFullProps) {
  return (
    <Section position="relative">
      <Flex direction="column" align="center" justify="center" maxW="4xl" mx="auto" textAlign={textAlign}>
        {sectionTitle && (
          <Text as="h2" textStyle="h4">
            {sectionTitle}
          </Text>
        )}
        {sectionDescription && (
          <Text fontSize="lg" mt={5}>
            {sectionDescription}
          </Text>
        )}
        <Video {...props} position="relative" mt={[8, 12]} />
      </Flex>
    </Section>
  );
}
